/**
 * MultiplayerScene.ts — Placeholder for future multiplayer
 *
 * Shows a "Coming Soon" message and provides a back button.
 * This exists so the scene key is registered and ready for v2.
 */

import * as Phaser from 'phaser';

export class MultiplayerScene extends Phaser.Scene {
  constructor() {
    super({ key: 'MultiplayerScene' });
  }

  create(): void {
    const { width, height } = this.scale;

    // Background
    this.cameras.main.setBackgroundColor('#f7f7f8');

    // "Coming Soon" text
    this.add.text(width / 2, height / 2 - 30, 'Multiplayer', {
      fontFamily: 'Outfit',
      fontSize: '2rem',
      color: '#1a1a1e',
    }).setOrigin(0.5);

    this.add.text(width / 2, height / 2 + 20, 'Coming soon...', {
      fontFamily: 'Outfit',
      fontSize: '1.2rem',
      color: '#8a8a96',
    }).setOrigin(0.5);

    // Back button
    const backText = this.add.text(width / 2, height / 2 + 80, '← Back to menu', {
      fontFamily: 'Outfit',
      fontSize: '1rem',
      color: '#1D4E89',
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    backText.on('pointerover', () => backText.setColor('#1a1a1e'));
    backText.on('pointerout', () => backText.setColor('#1D4E89'));
    backText.on('pointerdown', () => {
      this.scene.start('MenuScene');
    });
  }
}
